<template>
  <div id="content">
    <div class="inner">
      <p class="buttons">
        <router-link
            :to="{ name: 'landingPageEdit', params: { id: '*' } }"
            v-if="$_loggedUser_action_allowed('landingPage', 'update')"
            class="btn btn_action btn_grey btn_edit" v-translate
            :title="'Upravit' | translate"
        >
          Upravit
        </router-link>
      </p>
      <h1>{{ entity.title }}</h1>
    </div>
    <div class="inner_white" v-html="entity.body" />
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  entityName: 'landingPage',
  created(LandingPageService) {
    this.entityService = LandingPageService
    this.entityService.getEntity(null, { id_selected_operator: this.$_loggedUser_selectedOperatorId, })
        .then(data => {
          this.entity = data.landingPage
        })
  },
  data() {
    return {
      entity: {}
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/views/landingPage/LandingPage.vue